export const aciAirplanePlus = {
    iconName: 'airplane-plus',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M12.09 5.021c-.07.03-.138.1-.177.181l-.033.07v5.976H5.905l-.07.033a.328.328 0 00-.204.318c0 .147.068.253.203.317l.07.033h5.976v5.976l.033.07c.064.136.17.204.318.204a.328.328 0 00.317-.204l.034-.07V11.95h5.975l.07-.034a.328.328 0 00.204-.317.328.328 0 00-.204-.318l-.07-.033h-5.975V5.273l-.034-.07a.37.37 0 00-.18-.183.475.475 0 00-.278.001z',
                fill: 'currentColor',
            },
        },
    },
};
